var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentificationCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6562 24.0625H41.25",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6562 30.9375H41.25",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7877 30.9375C22.6354 30.9375 24.944 28.629 24.944 25.7812C24.944 22.9335 22.6354 20.625 19.7877 20.625C16.94 20.625 14.6315 22.9335 14.6315 25.7812C14.6315 28.629 16.94 30.9375 19.7877 30.9375Z",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1276 36.0938C13.5062 34.615 14.3663 33.3042 15.5722 32.3682C16.7781 31.4321 18.2612 30.9241 19.7877 30.9241C21.3143 30.9241 22.7974 31.4321 24.0033 32.3682C25.2092 33.3042 26.0692 34.615 26.4479 36.0938",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4062 10.3125H8.59375C7.64451 10.3125 6.875 11.082 6.875 12.0312V42.9688C6.875 43.918 7.64451 44.6875 8.59375 44.6875H46.4062C47.3555 44.6875 48.125 43.918 48.125 42.9688V12.0312C48.125 11.082 47.3555 10.3125 46.4062 10.3125Z",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationCard);
export default __webpack_public_path__ + "static/media/IdentificationCard.145554bbf05758afcc58497afc9cfb18.svg";
export { ForwardRef as ReactComponent };